export const Logo = ({ className = "h-9 w-9" }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="1" y="1" width="46" height="46" rx="14" className="fill-pitch dark:fill-turf" />
    <circle cx="24" cy="23" r="11.5" className="fill-cream dark:fill-[#0F1410]" />
    <path d="M24 15.5l6.6 4.8-2.5 7.8h-8.2l-2.5-7.8z" className="fill-pitch dark:fill-turf" />
    <path
      d="M24 11.5v4M30.6 20.3l3.9-1.3M27.9 28.1l2.4 3.3M20.1 28.1l-2.4 3.3M17.4 20.3l-3.9-1.3"
      className="stroke-pitch dark:stroke-turf"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M12 37.5h24" className="stroke-turf" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const BallIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 8.2l3.6 2.6-1.4 4.2h-4.4l-1.4-4.2z" fill="currentColor" />
    <path d="M12 4.5v3.7M15.6 10.8l3.5-1.2M14.2 15h3.7M9.8 15l-1.2 3.6M8.4 10.8L4.9 9.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export default Logo;
